// extracted by mini-css-extract-plugin
export default {"key":"Key_key__7Yuq2","playing":"Key_playing__A2kFz","soundName":"Key_soundName__XMeni"};